const getBackendEndpoint = () => {

  // console.log("Enviroment =>", process.env.NODE_ENV);
  // console.log("Enviroment Endpoint", process.env.REACT_APP_API_ENDPOINT);
  
  // If we have an environment variable, use it
  // if(process.env.REACT_APP_API_ENDPOINT){
  //   return process.env.REACT_APP_API_ENDPOINT
  // }

  // Check if we're in development mode (localhost)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8082/api/v1';
  }  
  // For production use the deployed backend
  return 'https://qkart-e-commerce-frontend.onrender.com/api/v1';
};
export default getBackendEndpoint